<template>
<div>
    <v-snackbar
      timeout="1500"
      top
      style="text-align:center"
      color="#c56060"
      v-model="snackbar"
    >
        {{snackInfo}}
    </v-snackbar>
  <div class="wrapper">
      <div class="content">
          <div>分享活动，许愿次数+1</div>
             
             <button class="copy" data-clipboard-text="http://lrzj.ylgame.com.cn/santa/index.html"><img src="../../assets/modal/confirm9.png" alt="" :class="{share: true, grey}">  </button>
      </div>
      <div class="code-wrapper">
          <div>长按识别小程序，抽取愿望实现卡</div>
          <div class="code">
              <img src="../../assets/code.png" alt="">
              <div>长按识别or保存抽奖小程序二维码</div>
          </div>
      </div>
      
  </div>
</div>
</template>

<script>
import ClipboardJS from 'clipboard'
import * as api from '@/api/index'
export default {
    name: 'wishShareCard',
    data() {
        return {
            clipboard: '',
            snackbar: false,
            snackInfo: ''
        }
    },
    props: ["wishData", "wishCount", "myWish"],
    computed: {
        grey() {
            return this.myWish.length > 1 || (this.myWish.length == 1 && this.wishCount > 0)
        }
    },
    mounted() {
        var clipboard = new ClipboardJS('.copy', {
            container: document.querySelector('.wrapper'),
          })
          clipboard.on('success', e => {
            console.log(e)
            // this.showSnack('复制成功')
            !this.grey && this.share()
          })
          clipboard.on('error', e => {
            console.log(e)
          })
        this.clipboard = clipboard
    },
    destroyed() {
       this.clipboard.destroy() 
    },
    methods: {
       showSnack(s) {
           this.snackbar = true
           this.snackInfo = s
       },
       async share() {
           const res = await api.share({
               activity_id: this.wishData.activity_id
           }).then(res => {
               this.$emit("wishShareCard-complete")
           }, err => {
               console.log(err)
           })
       }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 88.89vw;
    margin: 0 auto;
    margin-top: 18vw;
    min-height: 81.39vw;
    background-image: url("../../assets/modal/card.png");
    background-size: 100% 100%;
    overflow: hidden;
    .content {
        margin: 8vw auto 0;
        // width: 70%;
        text-align: center;
        min-height: 20vw;
        font-size: 22px;
        .share {
            width: 27.87vw;
            margin: 4vw auto;
            display: block;
        }
        .grey {
            filter: grayscale(10);
            border-radius: 10px;
        }
    }
    .code-wrapper {
        margin: 12vw 5vw 2vw;
        text-align: center;
        .code {
            font-size: 12px;
            img {
                width: 30vw;
                border-radius: 20px;
            }
        }
    }
  
}

</style>